import { useQuery } from '@tanstack/react-query'

import type { IUser } from '@albacross/types'

import { get, type Paginated } from 'utils/http'
import { getPaginatedTableQuery } from 'utils/url'

export const useUsers = (meta: any = {}) =>
  useQuery({
    queryKey: ['users', meta],
    queryFn: () => get<Paginated<IUser>>('/management/users', { query: getPaginatedTableQuery(meta) }),
  })
